module.exports = __webpack_public_path__ + "static/media/hotel-geotiller.421c2e98.svg";